import React from 'react';
import { useDocTitle } from '../hooks/useDocTitle';
import Hero from '../sections/Hero';
import Marquee from '../sections/Marquee';
import Manifesto from '../sections/Manifesto';
import EngineShowcase from '../sections/EngineShowcase';
import StorePreview from '../sections/StorePreview';
import Pillars from '../sections/Pillars';
import Ecosystem from '../sections/Ecosystem';
import WebGamesSection from '../sections/WebGamesSection';
import GamesShowcase from '../sections/GamesShowcase';
import Stats from '../sections/Stats';
import Vision from '../sections/Vision';
import NewsSection from '../sections/NewsSection';
import CTA from '../sections/CTA';
import Footer from '../sections/Footer';

export default function HomePage() {
  useDocTitle('pageTitles.home');

  return (
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <EngineShowcase />
      <StorePreview />
      <Pillars />
      <Ecosystem />
      <WebGamesSection />
      <GamesShowcase />
      <Stats />
      <Vision />
      <NewsSection />
      <CTA />
      <Footer />
    </main>
  );
}
